// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2405) return "static/chunks/2405-7cbcef4895ed13f3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5494":"a20dfcd3f52dfd42","9270":"546379c5651c1be2"}[chunkId] + ".js";
};